import { configMap } from '@src/configs';
import { TagTheme } from '@src/constants';

const getConfigByBrand = (tagTheme: TagThemeType): BrandThemeConfig => {
	const currentBrand = configMap.get(tagTheme);
	if (currentBrand) {
		return currentBrand;
	}

	return configMap.get(TagTheme.Lovet)!;
};

export default getConfigByBrand;
